/**
 * SettingToggle.jsx
 * Shared toggle row component used in AdminWhiteLabelManager builder settings panel.
 */
export function SettingToggle({ label, description, checked, onChange }) {
  return (
    <label className="flex items-center justify-between gap-4 rounded-lg border border-slate-200 px-4 py-3 cursor-pointer">
      <span>
        <span className="block text-sm font-medium text-slate-700">{label}</span>
        <span className="block text-xs text-slate-500 mt-0.5">{description}</span>
      </span>
      <input type="checkbox" checked={checked} onChange={event => onChange(event.target.checked)} className="h-4 w-4 accent-blue-600" />
    </label>
  );
}
